import VueDragscroll from "vue-dragscroll";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(VueDragscroll);
});